export {
  type AppGraphemeMeaningCard,
  appGraphemeMeaningCardTable,
} from "#app-grapheme-meaning-card-table";
